import { render, staticRenderFns } from "./CloseAssignmentModal.vue?vue&type=template&id=1f922b6a"
import script from "./CloseAssignmentModal.vue?vue&type=script&lang=js"
export * from "./CloseAssignmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports